import {computed, Injectable, signal} from '@angular/core'
import {TLoadItem} from '../0-application/types'

@Injectable({
  providedIn: 'root'
})
export class Loader {
  public readiness = signal<TLoadItem[]>([])

  public ready = computed(() => this.readiness().length === 0)

  public isReady(item: TLoadItem) {
    return !this.readiness().includes(item)
  }

  public isLoading(items: TLoadItem[]) {
    this.readiness.update(l => l.concat(items))
  }

  public isLoaded(item: TLoadItem) {
    this.readiness.update(l => l.filter(l => l !== item))
  }
}
